<template>
  <div
    class="fluid-grid intelligence-grid"
    :class="
      $slots.banner ? 'grid-rows-[auto_1fr_auto]' : 'grid-rows-[1fr_auto]'
    ">
    <div
      v-if="$slots.banner"
      class="z-48 span-full lg:top-[calc(var(--headerHeight)+var(--cvdNavigationHeight))]">
      <slot name="banner" />
    </div>
    <div class="span-popout h-full py-8">
      <slot></slot>
    </div>
    <div class="span-popout">
      <DpaNewsFooter footer-class="px-0" :has-disclaimer="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DpaNewsFooter from "@/components/shared/DpaNewsFooter/DpaNewsFooter.vue";
</script>
